export default "__VITE_PUBLIC_ASSET__ef9fd0c9__"